export default __webpack_public_path__ + "static/media/home-decor-1.05e218fd.jpeg";